import axios from 'axios'
import {getTemplateImageUrl} from 'utils/templateImageUrl'

const blobToDataUrl = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })

const fetchImageBlob = async (imagePath: string): Promise<Blob> => {
  const url = getTemplateImageUrl(imagePath)
  try {
    const response = await axios.get(url, {responseType: 'blob'})
    if (response.status !== 200 || !response.data?.size) {
      throw new Error(`No se pudo cargar la imagen (${response.status})`)
    }
    return response.data
  } catch (err: unknown) {
    const axiosErr = err as {response?: {status?: number}; message?: string}
    const status = axiosErr.response?.status
    const detail = status
      ? `Error ${status} al pedir ${url}`
      : axiosErr.message || 'Error de red'
    throw new Error(
      `${detail}. Verificá que certificados-loopback esté corriendo y tenga GET /files.`
    )
  }
}

/** Imagen lista para react-pdf (data URL base64). */
const fetchImageDataUrl = async (imagePath: string): Promise<string> => {
  const blob = await fetchImageBlob(imagePath)
  return blobToDataUrl(blob)
}

const exportedMethods = {
  fetchImageBlob,
  fetchImageDataUrl,
  getTemplateImageUrl,
}

export default exportedMethods
